import { render, staticRenderFns } from "./TicketDashboard.vue?vue&type=template&id=a4c09102&"
import script from "./TicketDashboard.vue?vue&type=script&lang=js&"
export * from "./TicketDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TicketDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports